// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"2f2428bb","498":"7c37e4ae","703":"09edbd7d","787":"ac84e98b"}[chunkId] + ".chunk.js";
};